import axios from 'axios'
import axiosClient from '../../../config/api/axios.js'
import { emitRunEvents } from './chatRunProgressEvents.js'
import { sleep } from './chatRunSleep.js'

const POLL_INTERVAL_MS = 1500
const POLL_TIMEOUT_MS = 30 * 60 * 1000
const MAX_CONSECUTIVE_NETWORK_ERRORS = 40

export function isChatRunPayload(data) {
  return Boolean(data && typeof data === 'object' && typeof data.runId === 'string' && typeof data.status === 'string' && typeof data.statusUrl === 'string')
}

export function isRetryableRunPollError(err) {
  if (axios.isCancel(err) || err?.code === 'ERR_CANCELED') return false
  return axios.isAxiosError(err) && !err.response
}

export async function waitForChatRun(run, signal, { onEvent } = {}) {
  const deadline = Date.now() + POLL_TIMEOUT_MS
  let consecutiveNetworkErrors = 0
  emitRunEvents(run, onEvent)
  while (Date.now() < deadline) {
    const status = String(run.status || '').toLowerCase()
    if (status === 'completed') return run.result || { __chatRunError: 'Hermes workflow completed without a response payload.' }
    if (status === 'needs_clarify' || status === 'needs_clarification') return run.result || { __chatRunError: 'Hermes workflow needs clarification but returned no prompt.' }
    if (status === 'failed') return { __chatRunError: run.error || 'Hermes workflow failed.' }

    await sleep(POLL_INTERVAL_MS, signal)
    let data
    try {
      const response = await axiosClient.get(run.statusUrl, { signal })
      data = response.data
      consecutiveNetworkErrors = 0
    } catch (err) {
      if (!isRetryableRunPollError(err)) throw err
      consecutiveNetworkErrors += 1
      if (consecutiveNetworkErrors >= MAX_CONSECUTIVE_NETWORK_ERRORS) throw err
      continue
    }
    if (!isChatRunPayload(data)) return { __chatRunError: 'Invalid Hermes run status response.' }
    run = data
    emitRunEvents(run, onEvent)
  }
  return { __chatRunError: 'Hermes workflow did not finish before the polling timeout.' }
}
